export const CORNERS =
  "M11.2593 4H9.33333C6.38782 4 4 6.38781 4 9.33333V11.2533M20.7407 4H22.6667C25.6122 4 28 6.38781 28 9.33333V11.2533M11.2593 28H9.33333C6.38782 28 4 25.6122 4 22.6667V20.7467M20.7407 28H22.6667C25.6122 28 28 25.6122 28 22.6667V20.7467";

export const LEFT_EYE =
  "M7.99976 14.1667C9.01217 14.1667 9.83356 14.9873 9.83374 15.9997C9.83374 17.0122 9.01228 17.8336 7.99976 17.8336C6.98738 17.8335 6.16675 17.0121 6.16675 15.9997C6.16692 14.9874 6.98749 14.1668 7.99976 14.1667Z";

export const MOUTH_SMILE =
  "M12.6667 17.3333C12.6667 17.3333 13.5556 18.6666 16.0001 18.6666C18.4445 18.6666 19.3334 17.3333 19.3334 17.3333";
export const MOUTH_TYPING = "M13.2 18.4C13.2 18.4 14.2 19.2 16 19.2C17.8 19.2 18.8 18.4 18.8 18.4";
